// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.lotus-casino-favourites-wrapper {
  width: 100%;
  margin-bottom: 24px;
}

.lotus-casino-favourites-wrapper .lotus-casino-lobby-group__title {
  margin-bottom: 12px;
}

.lotus-casino-favourites-empty {
  color: rgba(255, 255, 255, 0.55);
  font-size: 14px;
  padding: 24px 4px;
}
`, "",{"version":3,"sources":["webpack://./src/components/LotusCasinoShell/LotusCasinoRecommendedSection.css"],"names":[],"mappings":"AAAA;EACE,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gCAAgC;EAChC,eAAe;EACf,iBAAiB;AACnB","sourcesContent":[".lotus-casino-favourites-wrapper {\r\n  width: 100%;\r\n  margin-bottom: 24px;\r\n}\r\n\r\n.lotus-casino-favourites-wrapper .lotus-casino-lobby-group__title {\r\n  margin-bottom: 12px;\r\n}\r\n\r\n.lotus-casino-favourites-empty {\r\n  color: rgba(255, 255, 255, 0.55);\r\n  font-size: 14px;\r\n  padding: 24px 4px;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
